<template lang="pug">
div(:class="{'candidate-table-searching': $route.query.search}" data-test="candidate-list")
    v-data-table(
        v-model="activeItems"
        :headers="headers"
        :expanded.sync="expanded"
        single-expand=true
        :items="list"
        item-key="ID"
        show-select
        hide-default-footer
        hide-default-header
        multi-sort=false
        :sort-by.sync="sortModel.by"
        :sort-desc.sync="sortModel.desc"
        @update:sort-desc="updateSorting"
        :server-items-length="list.length"
        :single-select="false"
        :loading="loading"
        :mobile-breakpoint='NaN'
        class="app-table mt-4 elevation-1"
    )
        <template v-slot:top> 
          portal-target(name="candidate-list-top")
          
          .pr-4.pt-2.pb-2.d-flex.app-table__top(:class="{'select-bg-color': activeItems.length}")
            refresh-button(@click="loadList" v-show="!activeItems.length")
            div(v-if="activeItems.length").app-table__selected-items-title {{ activeItems.length}} items selected
            select-all(
              v-if="showSelectAll"
              @change="toggleSelectAllItems"
              :activeItemsCount="activeItems.length"
              :itemsToSelectCount="pagination.count"
            ).mx-2.my-1
            v-spacer

            hold(:activeItems="activeItems" @change="updateActiveItemsHold").mr-2
            accept-test(:activeItems="activeItems").mr-2
            acceptBulk(:activeItems="activeItems").mr-2
            emailBulk(:activeItems="activeItems")
            bulk-assign-labels(:disabled="!activeItems.length" :activeItems="activeItems").mr-2
            bulk-assign-labels(btnText="Unassign labels" mode="remove" :disabled="!activeItems.length" :activeItems="activeItems").mr-2
            handleFailedCandidatesProvider(v-slot="handleFailed")
              span.d-flex
                v-dialog(:value="handleFailed.showing" @input="handleFailed.toggle" scrollable)
                  handleFailedBody(
                    :list="handleFailed.failedCandidates"
                    :error="handleFailed.error"
                    :totalSendCount="handleFailed.totalSendCount"
                    @input="handleFailed.toggle"
                  )
                span.d-flex
                  mijn-bulk(
                    :disabled="!activeItems.length" 
                    :activeItems="activeItems"  
                    @send="handleFailed.check($event, activeItems.length)"
                  ).mr-2
                  exchange(
                    :disabled="!activeItems.length" 
                    :activeItems="activeItems" 
                    @send="handleFailed.check($event, activeItems.length)"
                  ).mr-2
            removeRequests(:disabled="!activeItems.length" :activeItems="activeItems").mr-2
            try-to-reserve(:activeItems="activeItems" :disabled="!activeItems.length").mr-2
            removeFromAcceptance(:disabled="!activeItems.length" :activeItems="activeItems").mr-2
            sync(:disabled="!activeItems.length" :activeItems="activeItems").mr-2
            copy(:activeItems="activeItems" :disabled="!activeItems.length" :list="list" multiple)

          v-divider
        
        </template>

        template(v-slot:header="headerRow")
          header-row(:headerRow="headerRow")

        template(v-slot:item="{item, select, isSelected, index, expand, isExpanded}")
          candidate-row(
            :item="item",
            :isSelected="isSelected"
            :select="select"
            :index="index"
            :expand="expand"
            :isExpanded="isExpanded"
            :pagination="pagination"
            :primaryPagination="primaryPagination"
            :key="index"
            :activeItems="activeItems"
            :labels="labels"
            @selectedWithShiftkey="extendedSelection"
            @onGoToEdit="goToEdit"
            @click:payments="paymentsOpen"
          )

        template( v-slot:expanded-item="{ headers, item }")
          td(:colspan="headers.length").pl-0.pr-0.app-table__expand
            candidate-item(
              :ID="item.ID"
              @close="hideExpandBy"
              ref="expand"
              :key='item.ID'
              @saved="updateTableDataBy(item, $event)"
            )
        
        template(v-slot:footer="{options}")
            .pagination(v-if="pagination")
                div.pagination__more
                    v-btn(color="primary" text class="mb-3 mt-3" data-test="candidate-loadmore" @click="onLoadMoreClick" :loading="loading" v-if="pagination.next") load more
                div.pagination__actions
                    v-pagination(
                        @input="paginationChange"
                        :disabled="loading"
                        :length="pagination.totalPages" 
                        v-model="pagination.page" 
                        :total-visible="8")
    payments-provider(:ID="1" ref="payments")
      template(v-slot:default="props")
        span
          payments-cancel-provider(
              :ID="props.ID" 
              :payments="props.logs"
              @end="props.create"
              @canceled="props.updateCanceledLog"
            )
              template(v-slot:default="{showing, cancelPayment, send, skip, toggle, showWhenHasCreatedPayment, processing}")
                span
                  v-dialog(:value="props.showing" :max-width="800" scrollable @input="props.toggle")
                    payments(
                      v-if="props.showing"
                      :items="props.list"
                      :itemsLoading="props.listLoading"
                      :formErrors="props.formErrors"
                      :editorData="props.editorData"
                      :processing="props.processing"
                      :log="props.logs"
                      @click:custom="props.setNewEditor"
                      @close="props.toggle"
                      @submit="showWhenHasCreatedPayment"
                    )
                      template(v-slot:log-actions="{ paymentLog }")
                        v-btn(small icon color="error" :loading="processing" @click="cancelPayment(paymentLog.ID)")
                          v-icon mdi-delete

                  confirmation-dialog(
                    v-model="showing"
                    @okBtnClicked="skip"
                    @failBtnClicked="toggle"
                    title="Candidate has payment"
                    descr="Are you sure you want to create new payment and cancel the old one?"
                    okText="ok"
                    failText="cancel"
                  )
    portal-target(name="candidate-create")


</template>

<script>
import {mapGetters, mapActions} from "vuex"

import SortModel from "./core/models/candidatesSortModel"
import {DRAWER_WIDTH} from "@/util/const"
import { FILTERS_ARGS, CANDIDATE_PAGE } from './core/candidates-const'
import copyMixin from "@/mixins/copy.mixin"
import itemModel from "./core/candidates-reservation-model"
import paginationMixin from '@/mixins/pagination.mixin'
import PaginationModel from "@/models/paginationModel"
import CandidateBroadcast from "./core/models/candidateBroadcast"
import CandidatePageMixin from "./core/candidates-page.mixin"
import errorsMixin from '@/mixins/errors.mixin'

export default {
  mixins: [copyMixin, paginationMixin, CandidatePageMixin, errorsMixin],

  data: () => ({
    headers: [
      { text: '', value: 'edit', class: 'app-table__h_small cell-btns', sortable: false },
      { text: '№', value: 'number', class: 'app-table__h_small cell-index ', align: 'left',  sortable: false },
      { text: 'Color', value: 'color', align: 'left', class: 'nowrap cell-placed-paid', sortable: true },
      { text: 'Placed/Paid', value: 'placed', align: 'left', class: 'nowrap cell-placed-paid', sortable: false },
      { text: 'Name', value: 'candidateName', align: 'left', class: 'cell-name', sortable: true },
      {
        text: 'CDN',
        align: 'left',
        sortable: false,
        value: 'candidateNumber',
        class: 'nowrap cell-number'
      },
      { text: 'DOB/Phone', value: 'candidateBirthday', class: 'nowrap cell-bday', align: 'center' },
      { text: 'CBR', value: 'accountUsername', align: 'left', class: 'cell-cbr'},
      { text: 'App ID', value: 'appId', align: 'center', class: 'cell-appid text-center', sortable: false},
      { text: 'Payment', value: 'payment', sortable: false, class: 'cell-payment'},

      { text: 'Reserved Info', value: 'reserved', align: 'center', class: 'cell-reserved', sortable: false },
      { text: 'Product', value: 'productName', align: 'left', class: 'cell-product', sortable: true },
      { text: 'Status', value: 'status', align: 'left', class: 'cell-status' },
      { text: '', value: 'delete', align: 'left', class: 'cell-delete'},
      { text: 'Last error', value: 'lastError', align: 'center', class: 'nowrap cell-error', sortable: false },
      { text: 'Comment', value: 'note', align: 'left', class: 'nowrap cell-app-note', sortable: false },
      { text: '', value: 'bov', align: 'center', class: 'nowrap cell-email', sortable: false },
      { text: 'Confirmed Courses', value: 'mainDate', align: 'left', class: 'cell-dates', sortable: false },
      { text: 'Reservation dates', value: 'requests', align: 'left', class: 'cell-reservation', sortable: false },
      { text: 'Note', value: 'note', align: 'center', sortable: false, class: 'cell-note' }, 
    ],
  }),

  inject: ['svc'],

  computed:{ 
  },


  methods: {
    async loadList({more = false}) {
      this._loadList({more, page: CANDIDATE_PAGE.RESERVE_EXCHANGE})   
    },
  },

  components: {
    candidateRow: () => import('./components/candidates/CandidateRowTask.vue'),
    candidateItem: () => import('./components/item/CandidateItem.vue'),
    copy: () => import('./components/candidates/CandidatesCopy.vue'),
    exchange: () => import('./components/CandidatesExchange.vue'),
    headerRow: () => import('./components/candidates/CandidatesHeaders.vue'),
    bulkAssignLabels: () => import('./components/candidates/CandidatesBulkAssignLabels.vue'),
    PaymentsProvider: () => import('./components/payments/CanidatesPaymentsProvider.vue'),
    Payments: () => import('./components/payments/CandidatesPayments.vue'),
    paymentsCancelProvider: () => import('./components/payments/CandidatesPaymentCancelProvider.vue'),
    emailBulk: () => import('./components/CandidatesEmail.vue'),
    mijnBulk: () => import('./components/CandidatesMIJNBulk.vue'),
    handleFailedCandidatesProvider: () => import('./components/CandidatesHandleFailedProvider'),
    handleFailedBody:() => import('./components/CandidatesHandleFailedBody.vue'),
    acceptBulk: () => import('./components/CandidateAcceptActivatorBulk.vue'),
    acceptTest: () => import('./components/CandidatesAcceptTest.vue'),
    removeRequests: () => import('./components/CandidatesRemoveExamRequest.vue'),
    tryToReserve: () => import('./components/CandidatesTryToReserve.vue'),
    refreshButton: () => import('./components/CandidatesRefreshButton.vue'),
    hold: () => import('./components/CandidateHold.vue'),
    removeFromAcceptance: () => import('./components/CandidatesRemoveFromAcceptance.vue'),
    sync: () => import('./components/CandidatesSync.vue'),
    selectAll: () => import('./components/CandidateSelectAll.vue'),

    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue')
  },

  beforeRouteLeave(to, from, next) {
    this.broadcast.close()
    next()
  },

  provide: function() {
    return {
      setCurrentHoldStatus: this.setCurrentHoldStatus,
      markAsProcessed: this.markAsProcessed,
      loadList: this.loadList,
    }
  },
  
}
</script>

<style lang="scss" scoped>
.candidate-table-searching {
  padding-bottom: 90px;
}


.app-table__expand {
  border: 1px solid $primary-color;
  border-top: unset;
}

.app-table::v-deep table {
  table-layout: fixed;
  min-width: 1725px;
  & th:first-child {
    width: 35px !important;
  }
  & th:last-child, td:last-child {
    padding-right: 8px;
  }
  .cell-btns {
    width: 60px;
  }
  .cell {
    &-name {
      width: 120px;
    }
    &-index {
      width: 36px;
    }
    &-cbr {
      width: 70px;
    }
    &-appid {
      width: 70px;
    }
    &-reserved {
      width: 122px;
    }
    &-bday {
      width: 95px;
    }
    &-hold {
      width: 68px;
    }
    &-status {
      width: 59px;
    }
    &-delete {
      width: 25px;
    }
    &-error {
      width: 100px;
    }
    &-email {
      width: 28px;
    }
    &-dates {
      width: 127px;
    }
    &-placed-paid {
      width: 90px;
    }
    &-reservation {
      width: 150px;
    }
    &-product {
      width: 80px;
    }
    &-number {
      width: 100px;
    }
    &-app-note {
      width: 80px;
    }
    &-note {
      text-align: center;
      min-width: 50px;
    }
    &-payment {
      width: 70px;
    }
  }
}
</style>
